var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconDocument = function SvgIconDocument(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.839996 0.280273V29.7203H25.16V0.280273H0.839996ZM14.28 23.9603H5.32V22.6803H14.28V23.9603ZM14.28 20.1203H5.32V18.8403H14.28V20.1203ZM14.28 16.2803H5.32V15.0003H14.28V16.2803ZM20.68 23.9603H17.48V22.6803H20.68V23.9603ZM20.68 20.1203H17.48V18.8403H20.68V20.1203ZM20.68 16.2803H17.48V15.0003H20.68V16.2803ZM20.68 7.32027H5.32V6.04027H20.68V7.32027Z",
    fill: "#6B7280"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconDocument);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAyNiAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODM5OTk2IDAuMjgwMjczVjI5LjcyMDNIMjUuMTZWMC4yODAyNzNIMC44Mzk5OTZaTTE0LjI4IDIzLjk2MDNINS4zMlYyMi42ODAzSDE0LjI4VjIzLjk2MDNaTTE0LjI4IDIwLjEyMDNINS4zMlYxOC44NDAzSDE0LjI4VjIwLjEyMDNaTTE0LjI4IDE2LjI4MDNINS4zMlYxNS4wMDAzSDE0LjI4VjE2LjI4MDNaTTIwLjY4IDIzLjk2MDNIMTcuNDhWMjIuNjgwM0gyMC42OFYyMy45NjAzWk0yMC42OCAyMC4xMjAzSDE3LjQ4VjE4Ljg0MDNIMjAuNjhWMjAuMTIwM1pNMjAuNjggMTYuMjgwM0gxNy40OFYxNS4wMDAzSDIwLjY4VjE2LjI4MDNaTTIwLjY4IDcuMzIwMjdINS4zMlY2LjA0MDI3SDIwLjY4VjcuMzIwMjdaIiBmaWxsPSIjNkI3MjgwIi8+Cjwvc3ZnPgo=";